import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import trim from "lodash/trim";
import {injectIntl} from "react-intl";

import FormGroup from "@mui/material/FormGroup";
import LookInput from "../../../ui/lookInput";
import {setCardErrors, setCardInfo} from "../../../../../actions/paymentFunctions";
import {supportedCountriesList} from "../../../../../reducers/cartReducer";
import LookDropdown from "../../../ui/lookDropdown";


const GroheCartPaymentInputs = (props) => {

  const {cardInfo, setCardInfo, inputsValidated, cardErrors, setCardErrors, intl} = props;

  const cardInputChange = (property, value) => {
    setCardInfo(property, value);
  }
  const getValidationErrors = (property, checkValue) => {
    const currentValue = trim(checkValue);
    const errors = [];

    switch (property) {
      case "cardName": {
        if (!currentValue) {
          errors.push("look.inputs.errors.missingCardName");
          return errors
        }
        if (currentValue.length === 1) {
          errors.push("look.inputs.errors.shortName");
        } else if (currentValue.length > 50) {
          errors.push("look.inputs.errors.longName");
        }
        if (!/^[A-Z\s\'\-\&\.a-z]+$/.test(currentValue)) {
          errors.push("look.inputs.errors.nameIsIncorrect");
        }
        break;
      }
      case "country": {
        if (!currentValue) {
          errors.push("look.inputs.errors.missingCountry");
          return errors
        }
        break;
      }
      case "cardNumber": {
        if (!currentValue) {
          errors.push("look.inputs.errors.missingCcNumber");
          return errors
        }
        break;
      }
      case "expMonth": {
        if (!currentValue) {
          errors.push("look.inputs.errors.missingExpMonth");
          return errors
        }
        break;
      }
      case "expYear": {
        if (!currentValue) {
          errors.push("look.inputs.errors.missingExpYear");
          return errors
        }
        break;
      }
      case "cvv": {
        if (!currentValue) {
          errors.push("look.inputs.errors.missingCVV");
          return errors
        }
        break;
      }
    }
    return errors
  }

  // const countryItems = [{text: intl.formatMessage({id: "look.inputs.selectCountry"}), value: ""}, ...supportedCountriesList.map(countryName => {
  const countryItems = supportedCountriesList.map(countryName => {
    return {text: countryName, value: countryName}
  })

  return (
    <FormGroup className="gc-form gc-form--row">
      {Object.keys(cardInfo).map(inputKey => {
        if (inputKey === "country") {
          return (
            <div className="gc-form__inputs-block" key={inputKey}>
              <div className="look-block">
                <LookDropdown
                  size={40}
                  selectLabel={intl.formatMessage({id: "look.inputs.country"}) + ":"}
                  selectItems={countryItems}
                  selectedItem={countryItems.find(countryItem => countryItem.value === cardInfo.country) || countryItems[0]}
                  selectItemClick={(selectItem) => cardInputChange(inputKey, selectItem.value)}
                  property={inputKey}
                  inputsValidated={inputsValidated}
                  errorsObject={cardErrors}
                  getValidationErrors={getValidationErrors}
                  changeErrorsObject={setCardErrors}/>
              </div>
            </div>
          )
        }
        return (
          <div className="gc-form__inputs-block" key={inputKey}>
            <LookInput property={inputKey}
                       inputsValidated={inputsValidated}
                       inputValue={cardInfo[inputKey]}
                       setInputValue={cardInputChange}
                       errorsObject={cardErrors}
                       getValidationErrors={getValidationErrors}
                       changeErrorsObject={setCardErrors}
                       isRequired={inputKey === "cardNumber"} />
          </div>
        )
      })}
    </FormGroup>
  )
};

GroheCartPaymentInputs.propTypes = {
  inputsValidated: PropTypes.bool
}

const mapStateToProps = (store) => {
  const {cardInfo, cardErrors} = store.paymentState;

  return {
    cardInfo,
    cardErrors,
  };
};

const mapDispatchToProps = {
  setCardInfo,
  setCardErrors,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(GroheCartPaymentInputs)
)
